export const greeting = {
  title: "Hi, I'm Suman",
  emogi: `emoji("👋")`,
  logo_name: "Suman",
  post: "Full-Stack Engineer",
  subTitle:
    "A self-motivated individual with problem-solving capability. Seeking an opportunity that allows me to best utilize the skillset and experience within the role of Full-Stack Engineer.",
  resumeLink:
    "https://drive.google.com/file/d/1uBv6T0iROjko52zHaRV7kpkZ7nFFWLNL/view",
  portfolioRepository:
    "https://github.com/SumanChakraborty1998/SumanChakraborty1998",
};

export const socialMediaLinks = [
  {
    name: "Mobile",
    link: "tel:8918070438",
    logo: "/Images/android3.png",
  },
  {
    name: "Gmail",
    link: "mailto:sumanchakra8145@gmail.com",
    logo: "/Images/gmail_svg.svg",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/suman-chakraborty-699308120/",
    logo: "/Images/linkedin_svg.svg",
  },
  {
    name: "Github",
    link: "https://github.com/SumanChakraborty1998/",
    logo: "/Images/github_svg.svg",
  },

  {
    name: "Twitter",
    link: "https://twitter.com/SumanCh03813504",
    logo: "/Images/twitter_svg.svg",
  },
];

export const projectLinks = [
  {
    title: "MotoSwap | Dex",
    image: "/Images/pepperfry.png",
    description:
      "A web application, which provides an online store for home essentials and room decorations according to their requirements",
    live_link: "https://pepperfry.netlify.app/",
    repo_link: "https://github.com/SumanChakraborty1998/MotoSwap",
    video_link: "https://youtu.be/xZdansoKAdM",
    tech_stack: [
      {
        name: "React",
        image: "/Images/react.svg",
      },
      {
        name: "Material UI",
        image: "/Images/mui.svg",
      },
      {
        name: "Solidity",
        image: "/Images/solidity.svg",
      },
      {
        name: "Ethers JS",
        image: "/Images/ethersjs.png",
      },
      {
        name: "Infura.io",
        image: "/Images/infura.png",
      },
      {
        name: "Ethereum",
        image: "/Images/ethereum.png",
      },
    ],
  },
  {
    title: "HelpifyMe | Crowd Funding",
    image: "/Images/helpifyme.png",
    description:
      "A decentralized application, which provides a platform for people to raise funds in emergency situation and help them financially",
    live_link: "https://helpify-me.vercel.app/",
    repo_link: "https://github.com/SumanChakraborty1998/helpify-me-crowdfund",
    video_link: "https://youtu.be/xZdansoKAdM",
    tech_stack: [
      {
        name: "React",
        image: "/Images/react.svg",
      },
      {
        name: "Material UI",
        image: "/Images/mui.svg",
      },
      {
        name: "Solidity",
        image: "/Images/solidity.svg",
      },
      {
        name: "Moralis.io",
        image: "/Images/moralis.jpg",
      },
      {
        name: "Ethereum",
        image: "/Images/ethereum.png",
      },
    ],
  },
  {
    title: "MotoPlayer | MP3 Play Dapp",
    image: "/Images/motoplayer.png",
    description:
      "A Dapp, which provides an online platform to listen the music hosted in the Blockchain. The music collection can be viewed in Opensea",
    live_link: "https://moto-player.netlify.app/",
    repo_link: "https://github.com/SumanChakraborty1998/MotoPlayer",
    video_link: "https://youtu.be/xZdansoKAdM",
    tech_stack: [
      {
        name: "React",
        image: "/Images/react.svg",
      },
      {
        name: "Ant Design",
        image: "/Images/antd.png",
      },
      {
        name: "Solidity",
        image: "/Images/solidity.svg",
      },
      {
        name: "Moralis.io",
        image: "/Images/moralis.jpg",
      },
      {
        name: "Ethereum",
        image: "/Images/ethereum.png",
      },
    ],
  },
  {
    title: "RajaMoto | Multi Sig Wallet",
    image: "/Images/multisig.png",
    description:
      "A decentralized application, which requires more than one owner to sign and authorize a crypto transaction",
    live_link: "https://rajamoto-multisig-wallet.vercel.app/",
    repo_link: "https://github.com/SumanChakraborty1998/MultiSignerWallet",
    video_link: "https://youtu.be/xZdansoKAdM",
    tech_stack: [
      {
        name: "React",
        image: "/Images/react.svg",
      },
      {
        name: "Material UI",
        image: "/Images/mui.svg",
      },
      {
        name: "Solidity",
        image: "/Images/solidity.svg",
      },
      {
        name: "Ethers JS",
        image: "/Images/ethersjs.png",
      },
      {
        name: "Infura.io",
        image: "/Images/infura.png",
      },
      {
        name: "Ethereum",
        image: "/Images/ethereum.png",
      },
    ],
  },
  {
    title: "NFT - Viswalizer",
    image: "/Images/nftvisualizer.png",
    description:
      "A decentralized platform, which provides the list of NFT's associated with a particular wallet address over the ethereum testnet",
    live_link: "https://rajamoto-nft-visualizer.vercel.app/",
    repo_link: "https://github.com/SumanChakraborty1998/nft-visualizer",
    video_link: "https://youtu.be/xZdansoKAdM",
    tech_stack: [
      {
        name: "React",
        image: "/Images/react.svg",
      },
      {
        name: "Material UI",
        image: "/Images/mui.svg",
      },
      {
        name: "Solidity",
        image: "/Images/solidity.svg",
      },
      {
        name: "Moralis.io",
        image: "/Images/moralis.jpg",
      },
      {
        name: "Ethereum",
        image: "/Images/ethereum.png",
      },
    ],
  },

  {
    title: "Pepperfry - Clone",
    image: "/Images/pepperfry.png",
    description:
      "A web application, which provides an online store for home essentials and room decorations according to their requirements",
    live_link: "https://pepperfry.netlify.app/",
    repo_link: "https://github.com/SumanChakraborty1998/pepperfry_clone",
    video_link: "https://youtu.be/xZdansoKAdM",
    tech_stack: [
      {
        name: "HTML-5",
        image: "/Images/html5.svg",
      },
      {
        name: "CSS-3",
        image: "/Images/css3.svg",
      },
      {
        name: "React",
        image: "/Images/react.svg",
      },
      {
        name: "Node",
        image: "/Images/node.svg",
      },

      {
        name: "MongoDB",
        image: "/Images/mongo.svg",
      },
    ],
  },
  {
    title: "Lumen5 - Clone",
    image: "/Images/lumen5.png",
    description:
      "A video creation platform that enables anyone without training or experience to create video content.",
    live_link: "https://sumanchakraborty1998.github.io/lumen5.github.io/",
    repo_link: "https://github.com/SumanChakraborty1998/Lumen5_clone",
    video_link: "https://youtu.be/7Y5idTeqSUs",
    tech_stack: [
      {
        name: "HTML-5",
        image: "/Images/html5.svg",
      },
      {
        name: "CSS-3",
        image: "/Images/css3.svg",
      },
      {
        name: "JavaScript",
        image: "/Images/js.svg",
      },
    ],
  },
  {
    title: "Desktime - Clone",
    image: "/Images/desktime.png",
    description:
      "A web application, which provides automatic time tracking for teams or individual in the organization for efficient outcome",
    live_link: "https://sumanchakraborty1998.github.io/desktime.github.io/",
    repo_link: "https://github.com/SumanChakraborty1998/desktime_clone",
    video_link: "https://youtu.be/R-y2CpOibFg",
    tech_stack: [
      {
        name: "HTML-5",
        image: "/Images/html5.svg",
      },
      {
        name: "CSS-3",
        image: "/Images/css3.svg",
      },
      {
        name: "JavaScript",
        image: "/Images/js.svg",
      },
    ],
  },
];

export const frontend_skills = [
  {
    name: "HTML-5",
    image: "/Images/html5.svg",
  },
  {
    name: "CSS-3",
    image: "/Images/css3.svg",
  },

  {
    name: "React",
    image: "/Images/react.svg",
  },
  {
    name: "Redux",
    image: "/Images/redux.svg",
  },
  {
    name: "Material-UI",
    image: "/Images/mui.svg",
  },
];

export const backend_skills = [
  {
    name: "Solidity",
    image: "/Images/solidity.svg",
  },
  {
    name: "Ethereum",
    image: "/Images/ethereum.svg",
  },
  {
    name: "Node.js",
    image: "/Images/node.svg",
  },
  {
    name: "Express",
    image: "/Images/express.svg",
  },

  {
    name: "MongoDB",
    image: "/Images/mongo.svg",
  },
];

export const tools_skills = [
  {
    name: "MetaMask",
    image: "/Images/metamask.png",
  },
  {
    name: "Truffle",
    image: "/Images/truffle.png",
  },
  {
    name: "Ganache",
    image: "/Images/ganache.png",
  },
  {
    name: "Hardhat",
    image: "/Images/hardhat.png",
  },
  {
    name: "Moralis",
    image: "/Images/moralis.svg",
  },
];

export const blogs = [
  {
    name: "A cloned version of pepperfry.com",
    symbol: "P",
    date: "March 13, 2021",
    image: "/Images/pepperfry.png",
    description:
      "Pepperfry is an Indian online marketplace for furniture and home decor. The company is headquartered in Mumbai, Maharashtra, and operates as a subsidiary of Trendsutra Platform Services Private Limited.",
    link: "https://sumanchakra8145.medium.com/pepperfry-clone-1653f65713aa",
  },
  {
    name: "A cloned version of lemen5.com",
    symbol: "L",
    date: "March 13, 2021",
    image: "/Images/lumen5.png",
    description:
      "Lumen5 is the easiest way to engage your audience and grow your brand on social media with professional video content. Lumen5 empowers you to create video content for social media.",
    link: "https://sumanchakra8145.medium.com/a-cloned-version-of-lumen5-com-97eaf52eaa42",
  },
  {
    name: "A cloned version of desktime.com",
    symbol: "D",
    date: "March 13, 2021",
    image: "/Images/desktime.png",
    description:
      "DeskTime is one kind of time-tracking web-app that helps an individual or a team to track their working time so that they can produce their efficient output. It is available in Android, and for IOS as well",
    link: "https://reach2suman.hashnode.dev/cloning-of-desktime-website-as-my-first-collaborative-work",
  },
];
